import axios from "axios";
import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import IsLoading from "../../../isLoading";
import "./formreciept.css";
import * as Action from "../../../store/redux/registrationReducer.js";
import Logo from "../public-routes-images/logos/Manga Cons-Logo.png";
import { useDispatch } from "react-redux";

let receiptData;
let continueationData;
export default function FormReciept() {
  const dispatch = useDispatch();
  const redirect = useNavigate();
  const [loading, setLoading] = useState(false);
  const { appNo } = useParams();
  const handlePrint = () => {
    const printContent = document.getElementById("receipt");
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent.innerHTML;
    window.print();
    document.body.innerHTML = originalContent;
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/student_application/${appNo}/print_reciept`
      );
      receiptData = response.data.data;
      continueationData = response.data.data;

      dispatch(DispatchContinuetion());
    } catch (error) {
      console.log("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const DispatchContinuetion = () => async (dispatch) => {
    try {
      dispatch(Action.continueAppForm({ continueationData }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="fx-cl space3">
      {loading ? <IsLoading /> : null}
      <div className="fx-cl space2 printRecpCont" id="receipt">
        <header className="fx-cl fx-ac fx-jc spacem">
          <figure className="receiptLogojn">
            <img src={Logo} alt="" />
          </figure>
          <h2>MANGA COLLEGE OF NURSING SCIENCES, ZURU</h2>
          <p>No. 2 Zuru Kontagora road, Amanawa Area, Zuru, Kebbi State</p>
          <p>(OFFICE OF THE REGISTRAR)</p>
        </header>
        <div className="fx-cl formPayReciept">
          <h3 className="fx-cl spacem">
            <span style={{ fontSize: "1.2rem", color: "#47484b" }}>
              Application form
            </span>
            <strong>Payment Reciept</strong>
          </h3>
          <div className="payDetail fx-cl space1">
            <div className="fx-jb space3">
              <strong>Name:</strong>{" "}
              <span>
                {receiptData?.first_Name +
                  " " +
                  receiptData?.sur_Name +
                  " " +
                  receiptData?.other_Name}
              </span>
            </div>
            <div className="fx-jb space3">
              <strong>Applicaiton No.:</strong>{" "}
              <span>{receiptData?.application_number}</span>
            </div>
            <div className="fx-jb space3">
              <strong>Payment Ref. No:</strong>{" "}
              <span>{receiptData?.account_status.reference_number}</span>
            </div>
            <div
              className="fx-jb space3"
              style={{ borderBottom: "1px solid #bfd3fa" }}
            >
              <strong>Email:</strong>
              <span>{receiptData?.email}</span>
            </div>

            <div className="fx-jb space3">
              <strong>Phone No.:</strong>{" "}
              <span>{receiptData?.phone_number}</span>
            </div>
            <div className="fx-jb space3">
              <strong>Discription:</strong>
              <span>Manga CONS Application form fee</span>
            </div>
            <div className="fx-jb space3">
              <strong>Transaction Status:</strong>
              <span>Paid</span>
            </div>
            <div
              className="fx-jb space3"
              style={{ borderBottom: "1px solid #bfd3fa" }}
            >
              <strong>Date:</strong>
              <span>{receiptData?.registered_date.date}</span>
            </div>

            <div className="fx-jb space3">
              <strong>Amount paid:</strong> <span>N10,000</span>
            </div>
          </div>
        </div>
      </div>
      <div className="fx-jc space3" style={{ marginBottom: "3.2rem" }}>
        <button
          style={{
            backgroundColor: "#065ad8",
            padding: "1.2rem 3.2rem",
            color: "#fff",
          }}
          onClick={() => handlePrint()}
        >
          Print receipt
        </button>

        <Link
          style={{
            backgroundColor: "#64f727",
            padding: "1.2rem 3.2rem",
            color: "#fff",
            fontSize: "1.4rem",
          }}
          to={`/continue_application/${receiptData?.application_number}`}
        >
          Continue Registration
        </Link>
      </div>
    </div>
  );
}
